import React, { useEffect, useState } from "react";
import { Button, Placeholder, Table } from "react-bootstrap";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";
import { useAuth } from "../../contexts/AuthContext";
import WorkspaceListItem from "./WorkspaceListItem";

const WorkspaceList = ({ ...props }) => {
  const { page, setCount, limit, loading, setLoading } = props;

  const [workspaceList, setWorkspaceList] = useState([]);
  const { currentUser } = useAuth();

  useEffect(() => {
    const fetchWorkspaces = async () => {
      try {
        const response = await Utils._apiRequest({
          path: Enums.endpoints.workspace.ALL,
          type: "GET",
          query: { page, limit },
        });
        setLoading(false);
        setWorkspaceList(response.data);
        setCount(response.count);
      } catch (error) {
        setLoading(false);
        console.log(error.message);
      }
    };

    setLoading(true);
    fetchWorkspaces();
  }, [page, limit, setCount, setLoading]);

  return (
    <OverlayScrollbarsComponent
      style={{ maxWidth: "100%" }}
      options={{ scrollbars: { autoHide: "scroll" } }}
    >
      <Table striped hover className="table-text-inline">
        <thead>
          <tr>
            <th style={{ width: 20 }}>#</th>
            <th>Name</th>
            <th>Description</th>
            <th>Owner</th>
            <th>Members</th>
            <th style={{ width: 150 }}>Created At</th>
            <th style={{ width: 120 }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <>
              {[...Array(limit).keys()].map((i) => {
                return (
                  <tr key={i} className="placeholder-group">
                    <td>{i + 1}</td>
                    <td>
                      <Placeholder animation="glow">
                        <Placeholder xs={10} />
                      </Placeholder>
                    </td>
                    <td>
                      <Placeholder animation="glow">
                        <Placeholder xs={12} />
                      </Placeholder>
                    </td>
                    <td>
                      <Placeholder animation="glow">
                        <Placeholder xs={8} />
                      </Placeholder>
                    </td>
                    <td>
                      <Placeholder animation="glow">
                        <Placeholder xs={4} />
                      </Placeholder>
                    </td>
                    <td>
                      <Placeholder animation="glow">
                        <Placeholder xs={8} />
                      </Placeholder>
                    </td>
                    <td className="text-inline text-end">
                      <Button
                        className="ms-1"
                        size="sm"
                        disabled
                        variant="warning"
                        title="Edit"
                      ></Button>
                    </td>
                  </tr>
                );
              })}
            </>
          ) : (
            <>
              {workspaceList.length > 0 ? (
                workspaceList.map((workspace, i) => {
                  return (
                    <WorkspaceListItem
                      key={i}
                      index={i}
                      workspace={workspace}
                      workspaceList={workspaceList}
                      setWorkspaceList={setWorkspaceList}
                    />
                  );
                })
              ) : (
                <tr>
                  <td colSpan={6}>
                    <i>
                      No workspaces found. You can create one to get started.
                    </i>
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </Table>
    </OverlayScrollbarsComponent>
  );
};

export default WorkspaceList;
